import angular from 'angular';
import _ from 'lodash';

import DateExtended from "serviceJs/date.service.ts";

import './api/contract';

angular.module('folkeuni').factory('Contract', function (ContractApi, $q, $filter) {
  var contract = this;

  contract.approve = function (contractObj) {
    var deferred = $q.defer();

    ContractApi.approve(contractObj).then(function (contractResponse) {
      deferred.resolve(contractResponse.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    })

    return deferred.promise;
  }

  contract.attachmentCreate = function (attachmentObj, file) {
    return ContractApi.attachmentCreate(attachmentObj, file);
  }

  contract.attachmentDelete = function (attachmentObj) {
    var deferred = $q.defer();

    ContractApi.attachmentDelete(attachmentObj).then(function (successResponse) {
      deferred.resolve(successResponse.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    })

    return deferred.promise;
  }

  contract.expenseTypes = [{
    id: "-1",
    label: "Vælg"
  },
  {
    id: "KØRSEL",
    label: "Kørsel i egen bil"
  },
  {
    id: "BRO",
    label: "Broafgift eller P-afgift"
  },
  {
    id: "TOG, BUS ELLER FÆRGE",
    label: "Tog, bus eller færge"
  },
  {
    id: "FLY",
    label: "Fly"
  },
  {
    id: "HOTEL",
    label: "Hotel"
  },
  {
    id: "MAD",
    label: "Mad"
  },
  {
    id: "DIÆT",
    label: "Diæt"
  },  
  {
    id: "TAXA",
    label: "Taxa"
  },
  {
    id: "DIVERSE",
    label: "Diverse bilag"
  }
  ];

  contract.getAllWaitingApproval = function () {
    var deferred = $q.defer();

    contract.getAllWithSumup().then(function (contracts) {
      
      var contractsWaitingApproval = [];
      for (var i = 0; contracts.length > i; i++) {
        var currentContract = contracts[i],
          allCancelled = true;

        for (var y = 0; currentContract.lines.length > y; y++) {
          if (!currentContract.lines[y].cancelled) {
            allCancelled = false;
          }
        }

        if (!currentContract.acceptedDate && !currentContract.declinedDate && !allCancelled) {
          contractsWaitingApproval.push(currentContract);
        }


      }
      deferred.resolve(contractsWaitingApproval);


    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });

    return deferred.promise;
  },

    contract.attachmentTypeLookup = function (typeId) {
      var typeName = "";

      for (var z in contract.expenseTypes) {
        var currentExpenseType = contract.expenseTypes[z];
        if (currentExpenseType.id == typeId) {
          typeName = currentExpenseType.label;
          break;
        }
      }

      return typeName;
    }

  contract.getAllEvents = function () {
    var deferred = $q.defer();

    contract.getAll().then(function (contractObj) {
      var contractLines = _.chain(contractObj).map(function (contract) {
        for (var i in contract.lines) {
          var currentLine = contract.lines[i];
          currentLine.attendance = contract.product.attendance;
          currentLine.visibleId = contract.product.visibleId;
          currentLine.name = contract.product.name;
          currentLine.locationSummary = contract.product.locationSummary;
        }

        return contract.lines;
      }).flatten().value();

      deferred.resolve(contractLines);

    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });

    return deferred.promise;
  }

  contract.getAllWithSumup = function () {
    //Make a sumup of locations and dates and add it to the contractObj
    var deferred = $q.defer();

    contract.getAll().then(function (contracts) {
      
      for (var y = 0; contracts.length > y; y++) {
        var currentContract = contracts[y],
          allCancelled = true;

        currentContract.datesAndLocations = [];
        currentContract.startDate = null;
        //Description for remunerationsType
        currentContract.remunerationTypeFormatted = currentContract.remunerationType == "FO" ? "Forelæsning" : "Kursus";

        for (var i = 0; currentContract.lines.length > i; i++) {
          try{
          var currentContractLine = currentContract.lines[i],
            dateSum = "";

          if (!currentContractLine.cancelled) {
            allCancelled = false;
          }
          var currentStartDate = new Date(currentContractLine.startDate);

          if(currentContract.startDate == null || currentContract.startDate > currentStartDate){
            currentContract.startDate = currentStartDate;
          }

          for (var x in currentContractLine.attachments) {
            var currentAttachment = currentContractLine.attachments[x];
            currentAttachment.typeName = contract.attachmentTypeLookup(currentAttachment.type);
          }

          const DateExtStart = new DateExtended(currentContractLine.startDate);
          const DateExtEnd = new DateExtended(currentContractLine.endDate);
          
          //Datefilter          
          if (
              DateExtStart.format("[DD][MM][YYYY]") &&
              DateExtEnd.format("[DD][MM][YYYY]")
          ) {
              dateSum =
                  DateExtStart.format("[DD].[MM].[YYYY] kl. [HH]:[mm]") +
                  " - " +
                  DateExtEnd.format("[HH]:[mm]");
          } else {
              dateSum =
                  DateExtStart.format("[DD].[MM].[YYYY] [HH]:[mm]") +
                  " - " +
                  DateExtEnd.format("[DD].[MM].[YYYY] kl. [HH]:[mm]");
          }

          var currentDateObj = {
            dateSum: dateSum,
            cancelledReason: currentContractLine.cancelledReason,
            cancelled: currentContractLine.cancelled != null
          }

          //Is location same as previous?
          if ((currentContract.datesAndLocations.length == 0 || (currentContractLine.location && currentContract.datesAndLocations && currentContract.datesAndLocations.length > 0 && currentContractLine.location.id != currentContract.datesAndLocations[currentContract.datesAndLocations.length - 1].location.id))) {

            var dateAndLocationItem = {
              dateDescription: [currentDateObj]
            }

            if (currentContractLine.location) {
              dateAndLocationItem.location = currentContractLine.location;
              dateAndLocationItem.locationGoogleMapUrl = "http://maps.google.com/?q=" + currentContractLine.location.postal + "," + currentContractLine.location.postal + "," + currentContractLine.location.address
            }
            else {
              dateAndLocationItem.location = null;
              dateAndLocationItem.locationGoogleMapUrl = null;
            }

            currentContract.datesAndLocations.push(dateAndLocationItem);
          } else {
            currentContract.datesAndLocations[currentContract.datesAndLocations.length - 1].dateDescription.push(currentDateObj);
          }
        }
        catch(err){

        }
        }
        currentContract.allCancelled = allCancelled;
      }
      
      deferred.resolve(contracts);
    }, function (errorResponse) {      
      deferred.reject(errorResponse);
    })
    return deferred.promise;
  };
  contract.getApprovedAndRejectedContracts = function (orderBy) {
    var deferred = $q.defer();

    contract.getAllWithSumup().then(function (contracts) {
      var contractsApprovedOrRejected = [];

      for (var i = 0; contracts.length > i; i++) {
        var currentContract = contracts[i];

        if (currentContract.acceptedDate || currentContract.declinedDate) {
          contractsApprovedOrRejected.push(currentContract);
        }
      }
      deferred.resolve(contractsApprovedOrRejected);


    }, function (errorResponse) {
      deferred.reject(errorResponse);
    });

    return deferred.promise;
  }

  contract.getAll = function (orderBy) {
    var deferred = $q.defer();

    ContractApi.getAll().then(function (contractResponse) {
      deferred.resolve(contractResponse.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    })
    return deferred.promise;
  };

  contract.reject = function (contractObj) {
    var deferred = $q.defer();

    ContractApi.reject(contractObj).then(function (rejectResponse) {
      deferred.resolve(rejectResponse.data);
    }, function (errorResponse) {
      deferred.reject(errorResponse);
    })
    return deferred.promise;
  }

  return contract;

});
